import React, { useState } from 'react';
import Popover from 'react-tiny-popover';

import PaymentCardItem from 'components/Payment/PaymentCardItem';
import PopoverMenu from 'components/Payment/PopoverMenu';
import { PaymentCard } from 'models/paymentCard';

export interface PopoverCardItemProps {
  card: PaymentCard;
  isDefault?: boolean;
  onRemove: () => void;
  onSetAsDefault?: () => void;
  onLinkToGroup?: () => void;
}
const PopoverCardItem = ({ card, isDefault, onRemove, onSetAsDefault, onLinkToGroup }: PopoverCardItemProps) => {
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  return (
    <Popover
      isOpen={isPopoverOpen}
      position={['bottom', 'top', 'right']}
      padding={0}
      onClickOutside={() => setIsPopoverOpen(false)}
      align="end"
      contentLocation={({ position, nudgedLeft, nudgedTop }) => {
        if (position === 'top') {
          return { top: window.scrollY + nudgedTop + 20, left: nudgedLeft + 10 };
        }
        return { top: window.scrollY + nudgedTop - 30, left: nudgedLeft + 10 };
      }}
      content={() => (
        <PopoverMenu
          closeMenu={() => setIsPopoverOpen(!isPopoverOpen)}
          isDefault={isDefault}
          onRemove={onRemove}
          onSetAsDefault={onSetAsDefault}
          onLinkToGroup={onLinkToGroup}
        />
      )}
    >
      <PaymentCardItem card={card} onClick={() => setIsPopoverOpen(!isPopoverOpen)} iconType="dots" />
    </Popover>
  );
};

export default PopoverCardItem;
